import { render, staticRenderFns } from "./setJump.vue?vue&type=template&id=526c4e16&scoped=true&"
import script from "./setJump.vue?vue&type=script&lang=js&"
export * from "./setJump.vue?vue&type=script&lang=js&"
import style0 from "./setJump.vue?vue&type=style&index=0&id=526c4e16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c4e16",
  null
  
)

export default component.exports